<script setup>
import { Loc } from 'main.core';
import { storeToRefs } from 'ui.vue3.pinia';
import useCalculatorStore from '../../../../store/calculator.js';

const calculator = useCalculatorStore();
const { selectedUsers } = storeToRefs(calculator);
</script>

<template>
  <p class="cloud-calculator__summary-row" v-if="selectedUsers > 0">
    <span class="cloud-calculator__summary-label">
      {{ Loc.getMessage('1CR_STSL_CLOUD_CALCULATOR_SUMMARY_LABEL_USERS') }}:
    </span>
    <span class="cloud-calculator__summary-value">
      {{ selectedUsers }}
    </span>
  </p>
</template>
